$('.js-downloadPresentation').on('click', function() {
    $(this).siblings('.footer-presentation-widget').slideToggle(100);
    $('.footer-presentation__back').fadeToggle();
    //
    // const footerPresentationElement = document.querySelector('.footer-presentation')
    //
    // if(footerPresentationElement.classList.contains('footer-presentation--active')) {
    //     footerPresentationElement.classList.remove('footer-presentation--active')
    // } else {
    //     footerPresentationElement.classList.add('footer-presentation--active')
    // }
})
